import React from 'react';
import PropTypes from 'prop-types';
import '@assets/css/common/style_main.css';

/**
 * 0-based 인덱스를 사용하는 페이지네이션 컴포넌트
 * Spring Boot 등의 백엔드 API와 호환
 */
const PaginationZeroBased = ({ 
  page = 0,              // 현재 페이지 (0부터 시작)
  totalPages = 0,        // 전체 페이지 수
  totalElements = 0,     // 전체 아이템 수
  size = 10,             // 페이지당 아이템 수
  hasNext = false,       // 다음 페이지 존재 여부
  hasPrevious = false,   // 이전 페이지 존재 여부
  onPageChange,          // 페이지 변경 핸들러
  pageGroupSize = 5      // 한 번에 보여줄 페이지 번호의 개수
}) => {
  
  // 페이지가 없거나 1페이지 이하인 경우 표시하지 않음
  if (!totalPages || totalPages <= 1) {
    return null;
  }

  // 현재 페이지 그룹 계산
  const currentGroup = Math.floor(page / pageGroupSize);
  
  // 현재 그룹의 시작 페이지와 끝 페이지 계산
  const startPage = currentGroup * pageGroupSize;
  const endPage = Math.min(startPage + pageGroupSize - 1, totalPages - 1);
  
  // 페이지 번호 배열 생성
  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }
  
  // 이전 페이지로 이동
  const goToPrevPage = () => {
    if (hasPrevious && page > 0) {
      onPageChange(page - 1);
    }
  };
  
  // 다음 페이지로 이동
  const goToNextPage = () => {
    if (hasNext && page < totalPages - 1) {
      onPageChange(page + 1);
    }
  };
  
  // 특정 페이지로 이동
  const goToPage = (pageNumber) => {
    if (pageNumber >= 0 && pageNumber < totalPages && pageNumber !== page) {
      onPageChange(pageNumber);
    }
  };
  
  return (
    <div className="pagination">
      {/* 이전 페이지 버튼 */}
      <a 
        href="#" 
        className={`page-nav ${!hasPrevious ? 'disabled' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          goToPrevPage();
        }}
      >
        <i className="ri-arrow-left-s-line"></i>
      </a>
      
      {/* 페이지 번호들 */}
      {pageNumbers.map(pageNum => (
        <a
          key={pageNum}
          href="#"
          className={`page-number ${pageNum === page ? 'active' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            goToPage(pageNum);
          }}
        >
          {pageNum + 1}
        </a>
      ))}
      
      {/* 다음 페이지 버튼 */}
      <a 
        href="#" 
        className={`page-nav ${!hasNext ? 'disabled' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          goToNextPage();
        }}
      >
        <i className="ri-arrow-right-s-line"></i>
      </a>
    </div>
  );
};

PaginationZeroBased.propTypes = {
  page: PropTypes.number,
  totalPages: PropTypes.number,
  totalElements: PropTypes.number,
  size: PropTypes.number,
  hasNext: PropTypes.bool,
  hasPrevious: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired,
  pageGroupSize: PropTypes.number
};

export default PaginationZeroBased;